/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Code generated by the Google Gen AI SDK generator DO NOT EDIT.

import * as common from '../_common.js';
import type * as types from '../types.js';

export function deleteDocumentConfigToMldev(
  fromObject: types.DeleteDocumentConfig,
  parentObject: Record<string, unknown>,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromForce = common.getValueByPath(fromObject, ['force']);
  if (parentObject !== undefined && fromForce != null) {
    common.setValueByPath(parentObject, ['_query', 'force'], fromForce);
  }

  return toObject;
}

export function deleteDocumentParametersToMldev(
  fromObject: types.DeleteDocumentParameters,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromName = common.getValueByPath(fromObject, ['name']);
  if (fromName != null) {
    common.setValueByPath(toObject, ['_url', 'name'], fromName);
  }

  const fromConfig = common.getValueByPath(fromObject, ['config']);
  if (fromConfig != null) {
    deleteDocumentConfigToMldev(fromConfig, toObject);
  }

  return toObject;
}

export function getDocumentParametersToMldev(
  fromObject: types.GetDocumentParameters,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromName = common.getValueByPath(fromObject, ['name']);
  if (fromName != null) {
    common.setValueByPath(toObject, ['_url', 'name'], fromName);
  }

  return toObject;
}

export function listDocumentsConfigToMldev(
  fromObject: types.ListDocumentsConfig,
  parentObject: Record<string, unknown>,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromPageSize = common.getValueByPath(fromObject, ['pageSize']);
  if (parentObject !== undefined && fromPageSize != null) {
    common.setValueByPath(parentObject, ['_query', 'pageSize'], fromPageSize);
  }

  const fromPageToken = common.getValueByPath(fromObject, ['pageToken']);
  if (parentObject !== undefined && fromPageToken != null) {
    common.setValueByPath(parentObject, ['_query', 'pageToken'], fromPageToken);
  }

  return toObject;
}

export function listDocumentsParametersToMldev(
  fromObject: types.ListDocumentsParameters,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromParent = common.getValueByPath(fromObject, ['parent']);
  if (fromParent != null) {
    common.setValueByPath(toObject, ['_url', 'parent'], fromParent);
  }

  const fromConfig = common.getValueByPath(fromObject, ['config']);
  if (fromConfig != null) {
    listDocumentsConfigToMldev(fromConfig, toObject);
  }

  return toObject;
}

export function listDocumentsResponseFromMldev(
  fromObject: types.ListDocumentsResponse,
): Record<string, unknown> {
  const toObject: Record<string, unknown> = {};

  const fromSdkHttpResponse = common.getValueByPath(fromObject, [
    'sdkHttpResponse',
  ]);
  if (fromSdkHttpResponse != null) {
    common.setValueByPath(toObject, ['sdkHttpResponse'], fromSdkHttpResponse);
  }

  const fromNextPageToken = common.getValueByPath(fromObject, [
    'nextPageToken',
  ]);
  if (fromNextPageToken != null) {
    common.setValueByPath(toObject, ['nextPageToken'], fromNextPageToken);
  }

  const fromDocuments = common.getValueByPath(fromObject, ['documents']);
  if (fromDocuments != null) {
    let transformedList = fromDocuments;
    if (Array.isArray(transformedList)) {
      transformedList = transformedList.map((item) => {
        return item;
      });
    }
    common.setValueByPath(toObject, ['documents'], transformedList);
  }

  return toObject;
}
